export default ['en', 'es'];
